import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-07311518")

_pushScopeId("data-v-07311518")
const _hoisted_1 = {
  key: 0,
  class: "pagination-container"
}
const _hoisted_2 = { class: "pagination-controls" }
const _hoisted_3 = { class: "page-of-text" }
const _hoisted_4 = { class: "pagination-info" }
const _hoisted_5 = { class: "goto-container" }
const _hoisted_6 = { class: "goto-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.totalPages > 1)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("button", {
            class: "pagination-btn prev-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args))),
            disabled: _ctx.currentPage === 1
          }, " < ", 8, ["disabled"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (page) => {
            return (_openBlock(), _createBlock("button", {
              key: page,
              class: ["pagination-btn page-number", { active: page === _ctx.currentPage, ellipsis: page === '...' }],
              onClick: ($event: any) => (typeof page === 'number' ? _ctx.goToPage(page) : null),
              disabled: page === '...'
            }, _toDisplayString(page), 11, ["onClick", "disabled"]))
          }), 128)),
          _createVNode("button", {
            class: "pagination-btn next-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
            disabled: _ctx.currentPage === _ctx.totalPages
          }, " > ", 8, ["disabled"]),
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("default.pagination.page_of", { current: _ctx.currentPage, total: _ctx.totalPages })), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("default.pagination.goto")), 1),
            _createVNode("select", {
              class: "goto-select",
              value: _ctx.currentPage,
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onGotoPageChange && _ctx.onGotoPageChange(...args)))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createBlock("option", {
                  key: page,
                  value: page
                }, _toDisplayString(page), 9, ["value"]))
              }), 128))
            ], 40, ["value"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})